import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function facturarProformaPresupuesto (data = null, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getTipoEsquema)
    })
  } else {
    const req = {
      url: 'api/emisionfacturas/facturarproformapresupuesto',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      params,
      data,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { facturarProformaPresupuesto }
